export default {
    TEAM: "team"
}
